import serialize from 'serialize-javascript';

const storeHoursMock = {
  monday: { open: '6:00', close: '21:00' },
  tuesday: { open: '6:00', close: '21:00' },
  wednesday: { open: '6:00', close: '21:00' },
  thursday: { open: '6:00', close: '21:00' },
  friday: { open: '6:00', close: '21:00' },
  saturday: { open: '6:00', close: '21:00' },
  sunday: { open: '8:00', close: '20:00' }
};

export const ContextBuilder = {
  server({ expConfiguration = {}, requestData = {}, hosts = {} }) {
    const experienceContext = {
      channel: requestData.channel || 'desktop',
      configService: {
        ...expConfiguration,
        searchStream: expConfiguration?.['search.stream'],
        searchStreamLimit: expConfiguration?.['search.streamLimit'],
      },
      cookie: {
        adobeCookie: requestData.adobeCookie
      },
      customer: requestData.customer,
      dataType: requestData.dataType,
      deliveryZip: requestData.deliveryZip,
      experiment: requestData.experiment || {},
      hosts,
      isConsumerApp: requestData.isConsumerApp,
      isDebugMode: requestData.isDebugMode,
      isLocal: typeof requestData.isLocal !== 'undefined'
        ? requestData.isLocal
        : false,
      localStoreZip: requestData.localStoreZip,
      path: (requestData.route && requestData.route.path) || '/',
      referer: requestData.referer,
      segment: requestData.segment,
      store: {
        storeHours: requestData.storeHours || storeHoursMock,
        storeId: requestData.storeId || '121',
        storeName: requestData.storeName || 'Cumberland',
        storeZip: requestData.localStoreZip || '30339'
      }
    };
    return {
      contextScript: `
      <script>window.__EXPERIENCE_CONTEXT__ =
      {
        "channel": ${serialize(experienceContext.channel)},
        "configService": ${serialize(experienceContext.configService)},
        "cookie": ${serialize(experienceContext.cookie)},
        "customer": ${serialize(experienceContext.customer)},
        "dataType": ${serialize(experienceContext.dataType)},
        "deliveryZip": ${serialize(experienceContext.deliveryZip)},
        "experiment": ${serialize(experienceContext.experiment)},
        "hosts": ${serialize({ ...experienceContext.hosts, api: '', www: '' })},
        "isConsumerApp": ${serialize(experienceContext.isConsumerApp)},
        "isDebugMode": ${serialize(experienceContext.isDebugMode)},
        "isLocal": ${serialize(experienceContext.isLocal)},
        "localStoreZip": ${serialize(experienceContext.localStoreZip)},
        "nearByStores": ${serialize(experienceContext.nearByStores)},
        "path": ${serialize(experienceContext.path)},
        "referer": ${serialize(experienceContext.referer)},
        "segment": ${serialize(experienceContext.segment)},
        "store": ${serialize(experienceContext.store)}
      }
      </script>
      `,
      experienceContext
    };
  },
  client({ expConfiguration = {} } = { expConfiguration: {} }) {
    const experienceContext = {
      channel: window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.channel,
      configService: {
        ...expConfiguration,
        searchStream: expConfiguration?.['search.stream'],
        searchStreamLimit: expConfiguration?.['search.streamLimit'],
      },
      cookie: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.cookie) || {},
      customer: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.customer) || {},
      dataType: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.dataType) || '',
      deliveryZip: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.deliveryZip) || '',
      experiment: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.experiment) || {},
      hosts: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.hosts) || {},
      isConsumerApp: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.isConsumerApp),
      isDebugMode: (window.__EXPERIENCE_CONTEXT__ && typeof window.__EXPERIENCE_CONTEXT__.isDebugMode !== 'undefined')
        ? window.__EXPERIENCE_CONTEXT__.isDebugMode
        : false,
      isLocal: window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.isLocal,
      localStoreZip: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.localStoreZip) || '',
      nearByStores: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.nearByStores) || [],
      path: window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.path,
      referer: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.referer) || '',
      segment: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.segment) || '',
      store: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.store) || {}
    };
    return {
      experienceContext
    };
  },
};
